import { useApp } from "src/hooks";
import { plural } from "src/utils/string";

/**
 * Generate a breadcrumb trail for a module.
 * @param {string} moduleName
 * @param {boolean} makePlural
 */
export default (moduleName, makePlural = false) => {
  const currentApp = useApp();
  const currentModuleTitle = makePlural
    ? plural(moduleName)
    : moduleName;

  const breadcrumbs = [
    {
      title: currentApp.appName,
      href: `${currentApp.path}`,
    },
    { title: currentModuleTitle },
  ];

  return breadcrumbs;
};
